// Кнопка-фильтр оверлея встроенного раздела (`run.type: "filter"`, значение
// «ключ=значение», несколько — через «&») применяет и естественный фильтр вшитого
// вида, если он у раздела есть:
//   Лента      — source=server|telegram|github|limits|notes (источник);
//   Трекер     — status=<id или название статуса-метки>;
//   Библиотеки — type=skill|agent|mcp, q=<строка поиска>.
// Повторное нажатие (снятие фильтра) возвращает вшитый вид к «всё».
// У Бесед, Заметок, Мессенджеров и Конструктора такого фильтра нет — там фильтр
// оверлея действует только на блоки оверлея.

import { useFeed } from '../feed/store'
import type { SourceId } from '../feed/store'
import { useLibrary } from '../library/store'
import type { LibType } from '../library/types'
import { useTracker } from '../tracker/store'

const FEED_SOURCES: SourceId[] = ['server', 'telegram', 'github', 'limits', 'notes']
const LIB_TYPES: LibType[] = ['skill', 'agent', 'mcp']

/** Разделы с естественным фильтром вшитого вида. */
export const BUILTIN_FILTERS = new Set(['feed', 'tracker', 'library'])

function parse(expr: string): Array<[string, string]> {
  return expr.split('&').map((part) => {
    const [k, ...rest] = part.split('=')
    return [k.trim().toLowerCase(), rest.join('=').trim()] as [string, string]
  }).filter(([k, v]) => k && v)
}

/** Применить фильтр к вшитому виду раздела `section`; `expr = null` — снять.
 *  true — у раздела есть такой фильтр и хоть что-то применилось. */
export function applyBuiltinFilter(section: string, expr: string | null): boolean {
  if (!BUILTIN_FILTERS.has(section)) return false
  const pairs = expr ? parse(expr) : []
  let applied = false
  if (section === 'feed') {
    const src = pairs.find(([k]) => k === 'source' || k === 'источник')?.[1].toLowerCase()
    if (!expr) { useFeed.getState().setSource(null); return true }
    if (src && FEED_SOURCES.includes(src as SourceId)) {
      useFeed.getState().setSource(src as SourceId)
      applied = true
    }
  } else if (section === 'tracker') {
    if (!expr) { useTracker.getState().setFilter(null); return true }
    const want = pairs.find(([k]) => k === 'status' || k === 'label' || k === 'статус')?.[1].toLowerCase()
    const labels = useTracker.getState().config?.labels ?? []
    const label = want ? labels.find((l) => l.id.toLowerCase() === want || l.title.toLowerCase() === want) : undefined
    if (label) {
      useTracker.getState().setFilter(label.id)
      applied = true
    }
  } else if (section === 'library') {
    const lib = useLibrary.getState()
    if (!expr) { lib.setTab('all'); lib.setQ(''); return true }
    const type = pairs.find(([k]) => k === 'type' || k === 'тип')?.[1].toLowerCase()
    const q = pairs.find(([k]) => k === 'q' || k === 'поиск')?.[1]
    if (type && LIB_TYPES.includes(type as LibType)) { lib.setTab(type as LibType); applied = true }
    if (q !== undefined) { lib.setQ(q); applied = true }
  }
  return applied
}
